import type { InputHTMLAttributes } from 'react';
import { FormFieldWrapper, FormFieldLabel, FormFieldInput } from './styled';

export interface AuthFormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
}

/**
 * Standard form input field with label for authentication forms.
 *
 * @component
 * @example
 * ```tsx
 * <AuthFormField
 *   id="email"
 *   type="email"
 *   label="Email Address"
 * />
 * ```
 *
 * @param {string} label - Label text
 * @param {string} id - Input element ID
 */
export function AuthFormField({ label, id, ...props }: AuthFormFieldProps) {
  return (
    <FormFieldWrapper>
      <FormFieldLabel htmlFor={id}>{label}</FormFieldLabel>
      <FormFieldInput id={id} {...props} />
    </FormFieldWrapper>
  );
}
